import styled from 'styled-components';

const MainContainer = styled.div`
    height: 100%;
    width: 100%;
`;

const ImageContainer = styled.div`
    position: relative;
    height: 100%;
    max-height: 768px;
    min-height: 400px;

    & img {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        max-width: 100%;
        object-fit: contain;
        object-position: top left;
    }
`;

const GreenHouse = ({ images = [] }) => {
    const baseUrl = `${process.env.PUBLIC_URL}/images/greenhouse/`;

    return (
        <MainContainer>
            <ImageContainer>
                {images.map((img) => {
                    return <img src={`${baseUrl}${img}`} alt="" key={img} />;
                })}
            </ImageContainer>
        </MainContainer>
    );
};

export default GreenHouse;
